<template>
  <nav class="pi-ai-nav" aria-label="Seções do assistente">
    <router-link v-for="link in links" :key="link.key" class="pi-ai-nav__link" :class="{ 'is-on': current === link.key }" :to="link.to"
                 :aria-current="current === link.key ? 'page' : null">{{ link.label }}</router-link>
  </nav>
</template>

<script>
import { subviewLinks } from "./piAssistantModel.js";

export default {
  name: "pi-assistant-nav",
  props: {
    current: { type: String, default: "chat" },
  },
  computed: {
    links() {
      return subviewLinks(this.$route && this.$route.query);
    },
  },
};
</script>

<style scoped>
.pi-ai-nav {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 6px;
  max-width: 100%;
  margin: 0 0 16px;
  padding: 4px;
  overflow-x: auto;
  border-radius: 8px;
  background: #f3f4f7;
}

.pi-ai-nav__link {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  color: #4e5560;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.pi-ai-nav__link:hover,
.pi-ai-nav__link:focus {
  color: #1d12b9;
  text-decoration: none;
}

.pi-ai-nav__link:focus {
  outline: 2px solid #1b59f8;
  outline-offset: -2px;
}

.pi-ai-nav__link.is-on {
  background: #ffffff;
  color: #1d12b9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piAssistantNav.vue